/* tslint:disable */
/* eslint-disable */
/**
 * TurboClaim API
 * TurboClaim API for insurance claim management. Includes claims, documents, estimates, supplements, billing, and chat operations. Authentication is JWT-based bearer token. 
 *
 * The version of the OpenAPI document: 1.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { GetOrganizationProperties200ResponseMeta } from './GetOrganizationProperties200ResponseMeta';
import {
    GetOrganizationProperties200ResponseMetaFromJSON,
    GetOrganizationProperties200ResponseMetaFromJSONTyped,
    GetOrganizationProperties200ResponseMetaToJSON,
    GetOrganizationProperties200ResponseMetaToJSONTyped,
} from './GetOrganizationProperties200ResponseMeta';
import type { OrganizationLinkedProperty } from './OrganizationLinkedProperty';
import {
    OrganizationLinkedPropertyFromJSON,
    OrganizationLinkedPropertyFromJSONTyped,
    OrganizationLinkedPropertyToJSON,
    OrganizationLinkedPropertyToJSONTyped,
} from './OrganizationLinkedProperty';

/**
 * 
 * @export
 * @interface GetOrganizationProperties200Response
 */
export interface GetOrganizationProperties200Response {
    /**
     * 
     * @type {Array<OrganizationLinkedProperty>}
     * @memberof GetOrganizationProperties200Response
     */
    properties: Array<OrganizationLinkedProperty>;
    /**
     * 
     * @type {GetOrganizationProperties200ResponseMeta}
     * @memberof GetOrganizationProperties200Response
     */
    meta?: GetOrganizationProperties200ResponseMeta;
}

/**
 * Check if a given object implements the GetOrganizationProperties200Response interface.
 */
export function instanceOfGetOrganizationProperties200Response(value: object): value is GetOrganizationProperties200Response {
    if (!('properties' in value) || value['properties'] === undefined) return false;
    return true;
}

export function GetOrganizationProperties200ResponseFromJSON(json: any): GetOrganizationProperties200Response {
    return GetOrganizationProperties200ResponseFromJSONTyped(json, false);
}

export function GetOrganizationProperties200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetOrganizationProperties200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'properties': ((json['properties'] as Array<any>).map(OrganizationLinkedPropertyFromJSON)),
        'meta': json['meta'] == null ? undefined : GetOrganizationProperties200ResponseMetaFromJSON(json['meta']),
    };
}

export function GetOrganizationProperties200ResponseToJSON(json: any): GetOrganizationProperties200Response {
    return GetOrganizationProperties200ResponseToJSONTyped(json, false);
}

export function GetOrganizationProperties200ResponseToJSONTyped(value?: GetOrganizationProperties200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'properties': ((value['properties'] as Array<any>).map(OrganizationLinkedPropertyToJSON)),
        'meta': GetOrganizationProperties200ResponseMetaToJSON(value['meta']),
    };
}

